/**
 * Formats an ISO date string ("2026-01-15") as "15 Jan 2026".
 * Returns an empty string for missing/invalid input rather than throwing,
 * since content frontmatter is hand-authored and may be incomplete.
 */
export function formatDate(isoDate) {
  if (!isoDate) return '';
  const date = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
